export const TRADE_URL_SELL_AMOUNT_KEY = 'sellAmount'
export const TRADE_URL_BUY_AMOUNT_KEY = 'buyAmount'
export const TRADE_URL_ORDER_KIND_KEY = 'orderKind'
